module.exports = "<div class=\"PLISTA\" data-ob-template=\"guardian\">\n    <div data-display=\"plista_widget_<%=widgetName%>\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./static/src/javascripts/projects/commercial/views/plista.html
// module id = 641
// module chunks = 0